export default {
  id: 14,
  pride: 22528,
  slug: "ue5-llm-game-plugin",
  portfolioKind: "study",
  category: "tool",
  status: "released",
  titleKey: {
    zh: "UE5大模型游戏插件",
    en: "UE5 LLM Game Plugin"
  },
  image: require('@/assets/images/co_plugin.webp'),
  descriptionKey: {
    zh: "毕设用的，其实啥游戏都可以用。后续有个大项目就还想用。",
    en: "Used for graduation project, applicable to any game. Planned for use in a future major project."
  },
  date: { year: 2023, month: 12 },
  genres: ["游戏引擎插件", "AI"],
  themes: ["LLM集成"],
  engine: "虚幻引擎 5",
  platform: ["PC"],
  tags: ["UE5", "开源"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "github", url: "https://github.com/tobenot/TobenotLLMGameplay", textKey: { zh: "GitHub 源码", en: "GitHub Source" } }
  ]
};
